import {
  setLocalStorageItem,
  getLocalStorageItem
} from '../localStorageHelpers'

const itemKey = site => {
  return `${site}-search-page-views`
}

export const shouldTrackSearchCount = site => {
  return site === 'themeforest'
}

export const searchesCount = site => {
  return getLocalStorageItem(itemKey(site), 0)
}

export const countSearchFor = site => {
  const newCount = getLocalStorageItem(itemKey(site), 0) + 1
  setLocalStorageItem(itemKey(site), newCount)
}



// WEBPACK FOOTER //
// ./common/utils/tracking/trackSearchCount.js